var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-user-carat"},[_c('span',{staticClass:"p-user-carat__label"},[_vm._v("\n    MyColorカラット:\n  ")]),_vm._v(" "),_c('span',{staticClass:"p-user-carat__number"},[_c('div',[_vm._v(_vm._s(_vm.carat)+" ct")])])])}
var staticRenderFns = []

export { render, staticRenderFns }